import React from "react";
import DepotToDepot from "../depotyodepot/DepotToDepot";
import DoorToDoor from "../doortodoor/DoorToDoor";
import TripOptions from "../inputfields/TripOptions";
import "./FormRoute.css";
import { FORM_HEADING_DOOR_TO_DOOR } from "./UserForm";
import { FORM_HEADING_DEPOT_TO_DEPOT } from "./UserForm";

const SHOW_DEPOT_TO_DEPOT = "depo";
const SHOW_DOOR_TO_DOOR = "door";

function FormRoute({
  depotList,
  toDepotList,
  selectedFrom,
  setSelectedFrom,
  selectedTo,
  setSelectedTo,
  estimatePrice,
  setFormHeading,
  setIsOnDepotToDepot,
  nextStep,
  quote,
}) {
  const [depotOrDoor, setDepotOrDoor] = React.useState(SHOW_DEPOT_TO_DEPOT);
  React.useEffect(() => {
    if (depotOrDoor === SHOW_DOOR_TO_DOOR) {
      setFormHeading(FORM_HEADING_DOOR_TO_DOOR);
      setIsOnDepotToDepot(false);
    } else if (depotOrDoor === SHOW_DEPOT_TO_DEPOT) {
      setFormHeading(FORM_HEADING_DEPOT_TO_DEPOT);
      setIsOnDepotToDepot(true);
    }
  }, [depotOrDoor]);
  return (
    <div className="formRouteMainContainer">
      <div className="formRouteContainer">
        <div className="formRouteTabs">
          <div
            className={
              depotOrDoor === SHOW_DEPOT_TO_DEPOT
                ? "routeDepotTabs route-active-tabs"
                : "routeDepotTabs"
            }
            onClick={setDepotOrDoor.bind(null, SHOW_DEPOT_TO_DEPOT)}
          >
            <div className="routeTabContent">Depot to Depot</div>
          </div>

          {/* FixMe: This is where I disabled the Door to Door option 2023/02/07 11:59 */}
          {/* <div
            className={
              depotOrDoor === SHOW_DOOR_TO_DOOR
                ? "routeDoorTabs route-active-tabs"
                : "routeDoorTabs"
            }
            onClick={setDepotOrDoor.bind(null, SHOW_DOOR_TO_DOOR)}
          >
            <div className="routeTabContent">Door to Door</div>
          </div> */}
        </div>
        <div className="formRouteContentTabs">
          <div
            className={
              depotOrDoor === SHOW_DEPOT_TO_DEPOT
                ? "formContent route-active-content"
                : "formContent"
            }
          >
            <DepotToDepot
              depotList={depotList}
              toDepotList={toDepotList}
              selectedFrom={selectedFrom}
              setSelectedFrom={setSelectedFrom}
              selectedTo={selectedTo}
              setSelectedTo={setSelectedTo}
              estimatePrice={estimatePrice}
              nextStep={nextStep}
            />
          </div>
          <div
            className={
              depotOrDoor === SHOW_DOOR_TO_DOOR
                ? "formContent route-active-content"
                : "formContent"
            }
          >
            <DoorToDoor quote={quote} nextStep={nextStep} />
          </div>
        </div>
      </div>
    </div>
  );
}

export default FormRoute;
